// Service.jsx
import { useTranslation } from '../../i18n/LanguageProvider';

/* ----------  DATA (unchanged)  ---------- */
const sections = [
  {
    title: 'Organizing Committee',
    years: {
      2026: [
        {
          label: 'SBSeg WGID',
          href:
            'https://www.sbseg2026.uff.br/',
        },
      ],
      2025: [
        {
          label: 'SBSeg WGID',
          href:
            'https://web.archive.org/web/20250228142507/https://sbseg2025.ppgia.pucpr.br/organizacao/organizacao-geral/',
        },
      ],
    },
  },
  {
    title: 'Technical Program Committee',
    years: {
      2026: [
        {
          label: 'ACM SAC DAPP',
          href:
            'https://web.archive.org/web/20251112231037/https://www.cas-blockchain-certification.com/en/pc-members-acm-sac-dapp',
        },
        {
          label: 'ACM SAC ISDE',
          href:
            'https://web.archive.org/web/20251112231002/https://ati.ttu.ee/sac-isde/#people',
        },
        {
          label: 'SBCUP',
          href:
            'https://web.archive.org/web/20260225033636/https://csbc.sbc.org.br/2026/sbcup/',
        },
        {
          label: 'SBRC-SF',
          href:
            'https://sbrc.sbc.org.br/2026/salao-de-ferramentas/',
        },
        {
          label: 'IEEE CBMS',
          href:
            'https://2026.cbms-conference.org/',
        },
        {
          label: 'SBSeg',
          href:
            'https://web.archive.org/web/20260606193351/https://www.sbseg2026.uff.br/chamadas/trilha-principal/',
        },       
      ],
      2025: [
        {
          label: 'ACM SAC DAPP',
          href:
            'https://web.archive.org/web/20241209212813/https://www.cas-blockchain-certification.com/en/pc-members-acm-sac-dapp',
        },
        {
          label: 'IEEE GBC',
          href:
            'https://web.archive.org/web/20250517001909/https://ieee-gbc.org/committee-technical-program-committee.html',
        },
        {
          label: 'IEEE CBMS',
          href:
            'https://web.archive.org/web/20250621021416/https://2025.cbms-conference.org/programme-committee/',
        },
        {
          label: 'SBSeg',
          href:
            'https://web.archive.org/web/20250228142551/https://sbseg2025.ppgia.pucpr.br/chamadas/trilha-principal/',
        },
        {
          label: 'SBRC-SF',
          href:
            'https://web.archive.org/web/20250517001535/https://sbrc.sbc.org.br/2025/en/salao-de-ferramentas/',
        },
        {
          label: 'WRSeg',
          href:
            'https://web.archive.org/web/20251112231716/https://crrc-rs.github.io/errc2025/wrseg/',
        },
      ],
      2024: [
        {
          label: 'ACM SAC DAPP',
          href:
            'https://www.cas-blockchain-certification.com/en/acm-sac-dapp-track',
        },
        {
          label: 'IEEE GBC',
          href:
            'https://web.archive.org/web/20240523023128/https://www.ieee-gbc.org/TPC.php',
        },
        {
          label: 'WRSeg',
          href:
            'https://web.archive.org/web/20241209212521/https://errc2024.c3.furg.br/WRSeg',
        },
      ],
      2023: [
        {
          label: 'ACM SAC DAPP',
          href:
            'https://www.cas-blockchain-certification.com/en/acm-sac-dapp-track',
        },
        {
          label: 'IEEE CBMS',
          href:
            'https://web.archive.org/web/20241209221215/https://csdl-downloads.ieeecomputer.org/proceedings/cbms/2023/1224/00/122400z036.pdf?Expires=1733782396&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9jc2RsLWRvd25sb2Fkcy5pZWVlY29tcHV0ZXIub3JnL3Byb2NlZWRpbmdzL2NibXMvMjAyMy8xMjI0LzAwLzEyMjQwMHowMzYucGRmIiwiQ29uZGl0aW9uIjp7IkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzMzNzgyMzk2fX19XX0_&Signature=Y7nms9CkfpSvpSqFP5UCDchLKoN~XFkrK2XpGU6kvdMRSYNHNPmlZsG3H0APrXapc1S97yfliGwVONT-iABZzEz0v0w533tYXtYg65x-R3oKl5rQbi88~EVAtflGY5p71dtmmSu~TazFUUJJcoIHzQbb7KNwYNjHcRVRgt72sy2VzGbUWxPpfKHIbgoZOmyjE-ThtkD21bfrKl7oF-~7zlxcZ~lwE1BGnMomJGRGWeghLunR8dFbs2JSigc-1d1HN5-tgO32aRET2eh1RWD~-5WQ2f9xf~aAaj0b9qbzcdi9wXJoNycCb161uvEMefprUrZyg5X1ZEa~CvRqb1i8ow__&Key-Pair-Id=K12PMWTCQBDMDT',
        },
        {
          label: 'WRSeg',
          href:
            'https://web.archive.org/web/20250621014414/https://errc2024.c3.furg.br/',
        },
      ],
      2022: [
        {
          label: 'ACM SAC DAPP',
          href:
            'https://web.archive.org/web/20241209214000/https://irp.cdn-website.com/2d2581a4/files/uploaded/acm-sac-2022-dapp-track-CFP-v3.pdf',
        },
      ],
      2019: [
        {
          label: 'ERES',
          href:
            'https://web.archive.org/web/20240717193011/http://eres.sbc.org.br/2019/comite.php',
        },
      ],
    },
  },
  {
    title: 'Reviewed for',
    years: {
      '2026': [
        {
          label: 'ACM Computing Surveys',
          href: 'https://dl.acm.org/journal/csur',
        },
        {
          label: 'Computer Networks',
          href: 'https://www.sciencedirect.com/journal/computer-networks',
        },
        {
          label: 'Computers, Materials and Continua',
          href: 'https://www.sciencedirect.com/org/journal/computers-materials-and-continua',
        },
        {
          label: 'Results in Engineering',
          href: 'https://www.sciencedirect.com/journal/results-in-engineering',
        },       
      ],
      '2025': [
        {
          label: 'Computer Networks',
          href: 'https://www.sciencedirect.com/journal/computer-networks',
        },
        {
          label: 'Journal of Network and Systems Management',
          href: 'https://link.springer.com/journal/10922',
        }],
      '2023': [
        {
          label: 'Ingeniería',
          href: 'https://revistas.udistrital.edu.co/index.php/reving',
        }],
      '2022': [
        {
          label: 'Journal of Network and Systems Management',
          href: 'https://link.springer.com/journal/10922',
        },
        {
          label: 'Journal of Internet Services and Applications',
          href: 'https://journals-sol.sbc.org.br/index.php/jisa',
        },
      ],
      '2021': [
        {
          label: 'Journal of Network and Systems Management',
          href: 'https://link.springer.com/journal/10922',
        },
      ],
    },
  },
];

/* ---------------------------------------------------------
   HELPER: render comma-separated links
   --------------------------------------------------------- */
const renderLinksInline = (items) =>
  items.map((it, i) => (
    <span key={it.label}>
      <a href={it.href} target="_blank" rel="noopener noreferrer">
        {it.label}
      </a>
      {i < items.length - 1 && ', '}
    </span>
  ));

/* ---------------------------------------------------------
   HELPER: sort years descending, non-numeric last
   --------------------------------------------------------- */
const sortYearsDesc = (entries) =>
  entries.sort(([a], [b]) => {
    const na = parseInt(a, 10);
    const nb = parseInt(b, 10);
    if (isNaN(na) && isNaN(nb)) return 0;
    if (isNaN(na)) return 1;
    if (isNaN(nb)) return -1;
    return nb - na;
  });

/* ---------------------------------------------------------
   COMPONENT
   --------------------------------------------------------- */
export default function Service() {
  const { t } = useTranslation();
  return (
    <div id="service" className="card mb-4">
      <div className="card-body">
        <h2 className="card-title">{t('home.service')}</h2>

        {sections.map(({ title, years }) => (
          <div key={title} className="mb-3">
            <h6 className="card-subtitle h6 mb-1">
              {title === 'Organizing Committee' ? t('sections.organizingCommittee') : title === 'Technical Program Committee' ? t('sections.technicalProgramCommittee') : t('sections.reviewedFor')}
            </h6>

            <ul className={title === 'Reviewed for' ? 'mb-0' : 'mb-1'}>
              {sortYearsDesc(Object.entries(years)).map(([year, items]) => (
                <li key={year}>
                  {year !== '-' && `${year}: `}
                  {renderLinksInline(items)}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
